import { useState, useEffect } from 'react';
import {
  DEFAULT_CHART_HEIGHT,
  MOBILE_CHART_HEIGHT,
  DESKTOP_BREAKPOINT_PX,
  CHART_HEIGHT_VIEWPORT_THRESHOLD,
  CHART_MIN_HEIGHT_SMALL,
  CHART_MIN_HEIGHT_LARGE,
  OVERVIEW_CHART_PADDING_AND_GAPS,
} from '../constants/countryDashboard';

/**
 * Computes Overview tab chart row height from header layout refs (desktop only).
 */
export default function useCountryDashboardChartHeight({
  activeTab,
  showHourlySimulator,
  country,
  globalHeaderRef,
  countryHeaderRef,
  tabNavigationRef,
}) {
  const [chartHeight, setChartHeight] = useState(DEFAULT_CHART_HEIGHT);

  useEffect(() => {
    const calculateChartHeight = () => {
      if (window.innerWidth < DESKTOP_BREAKPOINT_PX) {
        setChartHeight(MOBILE_CHART_HEIGHT);
        return;
      }

      if (activeTab !== 'overview' || showHourlySimulator) {
        return;
      }

      const globalHeader = globalHeaderRef.current;
      const countryHeader = countryHeaderRef.current;
      const tabNavigation = tabNavigationRef.current;

      if (!globalHeader || !countryHeader || !tabNavigation) {
        return;
      }

      const viewportHeight = window.innerHeight;
      const globalHeaderHeight = globalHeader.offsetHeight;
      const countryHeaderHeight = countryHeader.offsetHeight;
      const tabNavHeight = tabNavigation.offsetHeight;

      const availableHeight =
        viewportHeight -
        globalHeaderHeight -
        countryHeaderHeight -
        tabNavHeight -
        OVERVIEW_CHART_PADDING_AND_GAPS;

      const minHeight =
        viewportHeight < CHART_HEIGHT_VIEWPORT_THRESHOLD
          ? CHART_MIN_HEIGHT_SMALL
          : CHART_MIN_HEIGHT_LARGE;
      const calculatedHeight = Math.max(minHeight, Math.floor(availableHeight / 2));

      setChartHeight(calculatedHeight);
    };

    calculateChartHeight();
    window.addEventListener('resize', calculateChartHeight);
    return () => window.removeEventListener('resize', calculateChartHeight);
  }, [
    activeTab,
    showHourlySimulator,
    country,
    globalHeaderRef,
    countryHeaderRef,
    tabNavigationRef,
  ]);

  return chartHeight;
}
